<section
  customerScreenType
  class="s-full w-55 shadow-1 p-3 fx-col overflow-y-auto">
  <button
    id="close-sidebar"
    class="mr-n-3 mt-n-3 text-grey-400 ml-auto"
    mat-icon-button
    (click)="toggleSidebarRight && toggleSidebarRight()">
    <mat-icon
      class="pointer"
      fontIcon="close">
    </mat-icon>
  </button>

  <div class="w-full fx-center">
    <div class="s-15 overflow-hidden rounded">
      <img
        class="s-15 rounded"
        [src]="user?.photoURL || '/assets/images/svg/avatar.svg'"/>
    </div>
  </div>

  <div class="ellipsed mt-2 body-2 tw-text-grey-400 my-3">
    {{ user?.email }}
  </div>

  <customer-menu>
    <customer-menu-item
      value="logout"
      [withAction]="false"
      (click)="logout.emit()">
      <mat-icon fontIcon="logout">
      </mat-icon>
      {{ 'i18n.Common.logout' | translate }}
    </customer-menu-item>
  </customer-menu>
  <customer-menu class="mt-auto pt-3">
    <customer-menu-item
      *ngIf="withRefresh"
      id="refresh-now"
      value="refresh-now"
      [withAction]="false"
      (click)="refreshService.refresh$.next()">
      <mat-icon svgIcon="customer_refresh"></mat-icon>
      <span>
        {{ "i18n.Sidebar.refreshNow" | translate }}
      </span>
    </customer-menu-item>
    <customer-menu-item
      *ngIf="withRefresh && (refreshService.selectedRefreshTime$ | async) as refreshTime"
      id="refresh-time"
      tooltip
      tooltipMode="click"
      value="refresh-time"
      [withAction]="false"
      [tooltipTemplate]="selectRefreshTimeTemplate"
      [tooltipPosition]="tooltipsTemplatePosition">
      <mat-icon svgIcon="customer_time_refresh"></mat-icon>
      <span>
        {{ refreshTime.label }}
      </span>
    </customer-menu-item>
    <customer-menu-item
      *ngIf="withLanguage && (currentLang$ | async) as lang"
      id="language"
      tooltip
      class="text-capitalize"
      tooltipMode="click"
      value="language"
      [withAction]="false"
      [tooltipTemplate]="languageTemplate"
      [tooltipPosition]="tooltipsTemplatePosition">
      <mat-icon
        *ngIf="lang.src"
        slot="icon-only"
        [svgIcon]="lang.id">
      </mat-icon>
      <span>{{ lang.id }}</span>
    </customer-menu-item>
    <customer-menu-item
      *ngIf="withIdentityAreaNavigation"
      id="have-operator-code"
      value="have-operator-code"
      data-testid="account-error-identity-registration-button"
      [tooltipText]=" 'i18n.LimitedAccess.iHaveOperatorCode' | translate "
      [withAction]="false"
      (click)="goToIdentityRegistration()">
      <mat-icon>manage_accounts</mat-icon>
      <span>
        {{ "i18n.LimitedAccess.iHaveOperatorCode" | translate }}
      </span>
    </customer-menu-item>
    <customer-menu-item
      *ngIf="has_somePermission$ | async"
      id="migration-request"
      value="migration-request"
      [tooltipText]="'i18n.MigrationRequest.migrationRequest' | translate"
      [withAction]="false"
      (click)="goToMigrationRequest()">
      <mat-icon>
        group
      </mat-icon>
      <span>
        {{ "i18n.MigrationRequest.migrationRequest" | translate }}
      </span>
    </customer-menu-item>
    <customer-menu-item
      *ngIf="withZCSOperatorAreaNavigation && (is_ZCS_Operator$ | async)"
      id="service-area"
      value="service-area"
      [routerLink]="['/service']"
      [tooltipText]=" 'i18n.Common.zcsOperatorsArea' | translate "
      [withAction]="false">
      <mat-icon>support_agent</mat-icon>
      <span>
        {{ "i18n.Common.zcsOperatorsArea" | translate }}
      </span>
    </customer-menu-item>
    <customer-menu-item
      *ngIf="is_developer$ | async"
      id="appsync-env"
      tooltip
      tooltipMode="click"
      value="appsync-env"
      [withAction]="false"
      [tooltipTemplate]="appsyncEnvTemplate"
      [tooltipPosition]="tooltipsTemplatePosition">
      <mat-icon>dns</mat-icon>
      <span>
        {{ (envGateway$ | async) ?? 'Env' }}
      </span>
    </customer-menu-item>
    <customer-menu-item
      *ngIf="withKioskMode && { isTodayMode: todayModeService.todayMode$ | async } as resolved"
      id="today-mode"
      value="today-mode"
      [tooltipText]="(resolved.isTodayMode ? 'i18n.Sidebar.todayModeDisabled' : 'i18n.Sidebar.todayModeEnabled') | translate"
      [withAction]="false"
      (click)="changeTodayMode()">
      <mat-icon>desktop_windows</mat-icon>
      <span>
        {{ (resolved.isTodayMode ? "i18n.Sidebar.todayModeDisabled" :  "i18n.Sidebar.todayModeEnabled") | translate }}
      </span>
    </customer-menu-item>
  </customer-menu>

  <div class="bg-grey-100 fx-col fx-center my-3 radius-4 fx-gap-1 py-1 text-grey-400 tw-text-sm tw-font-normal">
    <span id="version-label">
      {{ "i18n.Common.version" | translate }}
    </span>
    <strong class="tw-text-base tw-font-medium">{{ version }}</strong>
  </div>
</section>

<ng-template #languageTemplate>
  <customer-language-selector></customer-language-selector>
</ng-template>

<ng-template #selectRefreshTimeTemplate>
  <customer-refresh-selector></customer-refresh-selector>
</ng-template>

<ng-template #appsyncEnvTemplate>
  <customer-appsync-env-selector></customer-appsync-env-selector>
</ng-template>
